import octogenImageLoader, {
  createImageOptimizerSrc,
  getImageOptimizerSourcePathFromSrc,
  isImageOptimizerSrc,
  shouldUseImageOptimizerLoader,
} from "@octogen/image-loader";

import {
  PRODUCT_IMAGE_OPTIMIZER_ROUTE_PREFIX,
  PRODUCT_IMAGE_SOURCE_CDN_HOST,
  isProductImageOptimizerFlagEnabled,
} from "@/lib/product-image-optimizer-config";

export { octogenImageLoader };

const PRODUCT_IMAGE_OPTIMIZER_OPTIONS = {
  sourceCdnHost: PRODUCT_IMAGE_SOURCE_CDN_HOST,
  routePrefix: PRODUCT_IMAGE_OPTIMIZER_ROUTE_PREFIX,
};

export function getProductImageOptimizerSourcePath(src: string): string | null {
  return getImageOptimizerSourcePathFromSrc(src, PRODUCT_IMAGE_SOURCE_CDN_HOST);
}

export function getProductImageOptimizerSrc(src: string): string {
  return createImageOptimizerSrc(src, {
    ...PRODUCT_IMAGE_OPTIMIZER_OPTIONS,
    isEnabled: isProductImageOptimizerFlagEnabled(),
  });
}

export function isProductImageOptimizerSrc(src: string): boolean {
  return isImageOptimizerSrc(src, PRODUCT_IMAGE_OPTIMIZER_OPTIONS);
}

export function shouldUseProductImageOptimizerLoader(src: string): boolean {
  return shouldUseImageOptimizerLoader(src, {
    ...PRODUCT_IMAGE_OPTIMIZER_OPTIONS,
    isEnabled: isProductImageOptimizerFlagEnabled(),
  });
}
